import './styles.scss';

import { Button, Link, Message, Stack, Text } from '@kolonialno/lama';
import { BrowserRouter as Router } from 'react-router';

import Container from './components/Container';
import Routes from './routing';
import {
    type AuthenticationContext,
    useAuthenticationContext,
} from './utils/context';
import { withRedirect } from './utils/redirect';

type UserAuthenticatedProps = {
    context: AuthenticationContext;
};
function UserAuthenticated({ context }: UserAuthenticatedProps) {
    const title = context.redirect
        ? undefined
        : 'You are already authenticated';

    return (
        <Container title={title}>
            {context.redirect && (
                <>
                    <Message variant="danger">
                        {context.userEmail
                            ? `You're signed in as ${context.userEmail}, which doesn't have access to ${context.applicationName ?? 'this application'}.`
                            : "You don't have access to this application."}
                    </Message>
                    <Text className="white-text">
                        If you used the wrong account, log out and sign in with
                        the right one. Otherwise, ask the people who manage this
                        application to give you access.
                    </Text>
                </>
            )}

            <Stack>
                <Button variant="primary" size="m" as="a" href="/">
                    Open application portal
                </Button>
            </Stack>

            <Link
                className="purple-text"
                as="a"
                href={withRedirect(context.logoutUrl, context.redirect)}
            >
                Log out
            </Link>
        </Container>
    );
}

function InnerApp(props: { children: React.ReactNode }) {
    const context = useAuthenticationContext();

    if (context.authenticated && !context.redirectConfirmation) {
        return <UserAuthenticated context={context} />;
    }

    return <div>{props.children}</div>;
}

function App() {
    return (
        <Router>
            <InnerApp>
                <Routes />
            </InnerApp>
        </Router>
    );
}

export default App;
